/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../../request.js";
import t from "../../core/Error.js";
import { queryAllJSON as r } from "../../layers/support/featureQueryAll.js";
import o from "../../portal/PortalItem.js";
import a from "../../rest/support/FeatureSet.js";
function n(e, t) {
  const r = [],
    o = new Map();
  for (const n of t) {
    const t = e.getLayerIdBySourceId(n.networkSourceId);
    if (null == t) continue;
    let r = o.get(t);
    void 0 === r && (r = []), r.push(n.objectId), o.set(t, r);
  }
  const a = e.featureServiceUrl;
  return o.forEach((e, t) => r.push({
    layerUrl: `${a}/${t}`,
    objectIds: e
  })), r;
}
async function s(e, t) {
  const o = e.layers,
    n = e.layerInfos,
    s = e.returnGeometry || !1,
    l = e.outSpatialReference;
  await Promise.all(o.map(async e => {
    await e.load();
  }));
  return (await Promise.all(o.map(async e => {
    const o = n.find(t => t.layerUrl === e.parsedUrl?.path);
    if (!o?.objectIds?.length) return {
      layer: e,
      featureSet: void 0
    };
    const i = e.createQuery();
    i.returnGeometry = s, i.outFields = o.outFields || ["*"], i.outSpatialReference = l, i.gdbVersion = e.gdbVersion, i.objectIds = o.objectIds, t && (i.where = "1=1");
    const u = a.fromJSON(await r(e, i));
    return {
      layer: e,
      featureSet: u
    };
  }))).filter(e => void 0 !== e.featureSet);
}
async function l(e, t) {
  if ("Utility Network Layer" === e) {
    const {
      default: e
    } = await import("../UtilityNetwork.js");
    return new e({
      layerUrl: t
    });
  }
  return null;
}
async function i(r) {
  let a = "portalItem" in r ? r : {
    portalItem: r
  };
  !a.portalItem || a.portalItem instanceof o || (a = {
    ...a,
    portalItem: new o(a.portalItem)
  });
  const n = a.portalItem;
  if (await n.load(), "Feature Service" !== n.type) throw new t("portal:unknown-item-type", "Unknown item type '${type}'", {
    type: n.type
  });
  const s = n.url,
    i = await e(s, {
      responseType: "json",
      query: {
        f: "json"
      }
    }),
    u = "Network Layer";
  if (i.data.type?.includes(u)) return l(i.data.type, s);
  if (i.data.layers) {
    const e = i.data.layers.find(e => e.type.includes(u));
    if (e) {
      const t = `${s}/${e.id}`;
      return l(e.type, t);
    }
  }
  return null;
}
export { s as getFeaturesFromLayers, n as getObjectIdsFromElements, i as networkFromPortalItem };